import React, {useEffect, useState} from 'react'
import axios from 'axios'
import Product from '../product';
import "./similarProducts.css"
function SimilarProducts() {
    const [loader, setLoader]=useState();
    const [allProducts, setAllProducts]=useState([]);
    
    useEffect(() => {
       
        axios({
          method: "get",
          url: process.env.REACT_APP_BACKEND_URL + "shop/Products",
          headers: { "Content-Type": "multipart/form-data" },
        }).then((resp) => {
          setAllProducts(resp.data.products);
          setLoader(false);
          resp.data.products[0].map(key => {
            console.log(key +" : "+resp.data.products[0][key])
          });
        //   resp.data.products.forEach((product, index) => {
        //     console.log(`Product ${index + 1} Properties:`);
        //     Object.keys(product).forEach((key) => {
        //       console.log(`${key}:`, product[key]);
        //     });
        //     console.log("-------");
        //   });
        });
      }, []);
  return (
    <div className="SimilarProductsGrid">
    { 
        // allProducts!=null ?  
        allProducts.map((item)=>(
              <Product
                key={item._id}
                id={item._id}
                name={item.name}
                item={item}
                description={item.description}
                price={item.price}
                category={item.category}
                image={item.images.url}
              />
    )) 
   // : <div>wait</div>
    }
    </div>
  )
}

export default SimilarProducts